import { get } from "../methods";
function getDownloadDetailedReturnsCSV(payload, headers = {}) {
  const { portfolioId, startDate, endDate } = payload;
  return get({
    url: `backend/portfolio/portfolio-transaction/download-report/${portfolioId}?startDate=${startDate}&endDate=${endDate}`,
    headers
  });
}
export {
  getDownloadDetailedReturnsCSV as default
};
